import type { FC, ReactNode } from "react";

import {
  wrapperStyle,
  cardStyle,
  contentPanelStyle,
  contentInnerStyle,
  imagePanelStyle,
  imageStyle,
} from "./VerenigingEigenHuisAuthWrapper.css";
import { Flex, Logo } from "@huub-web/ui";

const AUTH_IMAGE_SRC =
  "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/2ac32139-e0e7-417c-b46f-2c276c375ba5/Wavisch_200522_VEH_Enschede_342.jpg?fm=webp&lossless=0&q=80&w=1200&h=870&fit=crop";

export const VerenigingEigenHuisAuthWrapper: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  return (
    <div className={wrapperStyle}>
      <Flex direction="column" className={cardStyle}>
        <Flex justify="center" shrink={false} className={contentPanelStyle}>
          <Flex direction="column" gap="m" className={contentInnerStyle}>
            <Logo theme="verenigingEigenHuis" size="l" />
            {children}
          </Flex>
        </Flex>
        <div className={imagePanelStyle}>
          <img
            className={imageStyle}
            src={AUTH_IMAGE_SRC}
            alt=""
            loading="eager"
          />
        </div>
      </Flex>
    </div>
  );
};
